import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth, getEnvVar } from '@immopersian/common';
import CoursesListPage from './pages/CoursesListPage';
import CourseDetailPage from './pages/CourseDetailPage';
import SettingsPage from './pages/SettingsPage';
import WebinarRoomPage from './pages/WebinarRoomPage';
import { LoadingScreen } from './components/LoadingScreen';

function App() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    const loginUrl = getEnvVar('VITE_LOGIN_URL');
    window.location.href = loginUrl;
    return null;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CoursesListPage />} />
        <Route path="/course/:courseId" element={<CourseDetailPage />} />
        <Route path="/webinar/:webinarId" element={<WebinarRoomPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
